import { render, staticRenderFns } from "./Login-1.vue?vue&type=template&id=edc986d2"
import script from "./Login-1.vue?vue&type=script&lang=js"
export * from "./Login-1.vue?vue&type=script&lang=js"
import style0 from "./Login-1.vue?vue&type=style&index=0&id=edc986d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports